import { Outlet } from "react-router-dom";
import AuthHeader from "../header/AuthHeader";
import NavBar from "../navBar";
import PrivateRoute from "../../routes/components/PrivateRoute";


const UserDashboardLayout = () => {
  return (
    <PrivateRoute>
      <AuthHeader />
      <main className="main dashboard">
        <NavBar />
        <Outlet />
      </main>
    </PrivateRoute>
  );
};

export default UserDashboardLayout;
